// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606300009/js/" + chunkId + "." + {"44":"07f92558","225":"10470ed1","481":"25b69d65","486":"e1d99fe1","770":"027c726c"}[chunkId] + ".0.902910364758937.chunk.js";
};